import React, { useCallback, useRef, useEffect, } from 'react';
import classnames from 'classnames';
import { EmoteStreamType } from '../redux/types';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import s from './Emote.scss';
// TODO: Add lazy loading
var Emote = function (_a) {
    var _b = _a.emote, type = _b.type, src = _b.src, title = _b.title, emote = _a.emote, onClick = _a.onClick, onKeyDown = _a.onKeyDown, onFocus = _a.onFocus, onBlur = _a.onBlur, focused = _a.focused, tabIndex = _a.tabIndex, ariaColIndex = _a["aria-colindex"], role = _a.role;
    var buttonRef = useRef(null);
    var backgroundImage = "url(" + src + ")";
    var handleMouseHover = useCallback(function (e) {
        if (e.target && e.target.style) {
            e.target.style.backgroundImage = backgroundImage + ", linear-gradient(45deg, rgba(76, 221, 189, .18), rgba(6, 242, 134, .18))";
        }
    }, [backgroundImage]);
    var handleMouseOut = useCallback(function (e) {
        if (e.target && e.target.style) {
            e.target.style.backgroundImage = backgroundImage;
        }
    }, [backgroundImage]);
    useEffect(function () {
        if (focused && buttonRef.current) {
            buttonRef.current.scrollIntoView({
                block: 'nearest',
            });
            buttonRef.current.focus({ preventScroll: true });
        }
    }, [focused, buttonRef]);
    return (React.createElement(PlainButtonOrLink, { innerRef: function (node) {
            buttonRef.current = node;
        }, tabIndex: tabIndex, onClick: function (e) { return onClick(emote, e); }, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, onMouseOver: handleMouseHover, onMouseOut: handleMouseOut, className: classnames(s['emote'], type === EmoteStreamType.OFFICIAL && s['emote-pixel'], type !== EmoteStreamType.OFFICIAL && s['not-official']), style: {
            backgroundImage: backgroundImage,
        }, "aria-colindex": ariaColIndex, role: role },
        React.createElement("span", { className: s['title'] }, title)));
};
Emote.displayName = 'Emote';
export default Emote;
//# sourceMappingURL=Emote.js.map